import { useTranslation } from 'react-i18next'
import { useScrollReveal } from '@/hooks/use-scroll-reveal'
import Container from '@/components/ui/container'
import Icon from '@/components/ui/icon'

interface Principle {
  icon: string
  title: string
  description: string
}

export default function Principles() {
  const { t } = useTranslation()
  const { ref, visible } = useScrollReveal()
  const items = t('about.principles.items', { returnObjects: true }) as Principle[]

  return (
    <section ref={ref} className="py-16 md:py-24 lg:py-32">
      <Container>
        <div
          className={`text-center mb-10 md:mb-16 lg:mb-20 transition-all duration-700 ease-out ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="text-primary font-body text-label-md uppercase tracking-[0.4em] mb-4 block">
            {t('about.principles.label')}
          </span>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter uppercase">
            {t('about.principles.heading')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className={`group p-5 md:p-8 border border-outline-variant/20 hover:border-primary/40 transition-all duration-500 ease-out ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: visible ? `${300 + i * 100}ms` : '0ms' }}
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6 text-primary">
                <Icon name={item.icon} className="text-3xl" />
              </div>
              <h3 className="font-display text-xl font-bold tracking-tight text-on-surface mb-3 uppercase">
                {item.title}
              </h3>
              <p className="text-on-surface-variant text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
